module.exports = __webpack_public_path__ + "static/img/soBg.bd5ec62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/soBg.jpg
// module id = Jmp1
// module chunks = 11